export const userDataPatterns = {
  phone: {
    regexp: '(\\([1-9]{2}\\))\\s([6-9]{1})([0-9]{4})-([0-9]{4})',
    error: 'Digite um telefone válido',
  },
  email: {
    regexp: '[a-zA-Z0-9._%+-]+@[a-z0-9]+\\.[a-z]+.([a-z]+)?',
    error: 'Digite um email válido',
  },
  cep: {
    regexp: '([0-9]{5})-([0-9]{3})',
    error: 'Digite um cep válido',
  },
  cpfOrCnpj: {
    regexp:
      '(^\\d{3}\\.\\d{3}\\.\\d{3}\\-\\d{2}$)|(^\\d{2}\\.\\d{3}\\.\\d{3}\\/\\d{4}\\-\\d{2}$)',
    error: 'Digite um cpf ou cnpj válido',
  },
  birthday: {
    regexp:
      '^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$',
    error: 'Data inválida',
  },
  founded_at: {
    regexp:
      '^(((0[1-9]|[12][0-9]|30)[-/]?(0[13-9]|1[012])|31[-/]?(0[13578]|1[02])|(0[1-9]|1[0-9]|2[0-8])[-/]?02)[-/]?[0-9]{4}|29[-/]?02[-/]?([0-9]{2}(([2468][048]|[02468][48])|[13579][26])|([13579][26]|[02468][048]|0[0-9]|1[0-6])00))$',
    error: 'Data inválida',
  },
};

export const creditCardPatterns = {
  validDate: {
    regexp: '[0-9]{2}/[0-9]{4}',
    error: 'Data invalido',
  },
  cvv: {
    regexp: '[0-9]{3}',
    error: 'Código invalido',
  },
  number: {
    regexp: '^(4|5)[0-9]{3}\\s[0-9]{4}\\s[0-9]{4}\\s[0-9]{4}',
    error: 'Digite um número valido',
  },
};
